import React, { useMemo } from 'react'
import Select, { type SingleValue, type StylesConfig } from 'react-select'
import { hydroReactSelectStyles } from '@/lib/hydroReactSelectStyles'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'
import type { DeviceRole } from '../context/DeviceContext'

type PumpOption = { value: string; label: string }

const PUMP_OPTIONS: PumpOption[] = [
    { value: 'Water', label: 'Water' },
    { value: 'pH Down', label: 'pH Down' },
    { value: 'pH Up', label: 'pH Up' },
    { value: 'A', label: 'Nutrient A' },
    { value: 'B', label: 'Nutrient B' },
    { value: 'C', label: 'Nutrient C' },
]

const pumpSelectStyles = hydroReactSelectStyles as StylesConfig<PumpOption, false>

type PumpTypeProps = {
    pumpNumber: number
    pumps: DeviceRole[]
    setPumps: React.Dispatch<React.SetStateAction<DeviceRole[]>>
}

const PumpType = ({ pumpNumber, setPumps, pumps }: PumpTypeProps) => {
    const value: PumpOption | null = useMemo(() => {
        const role = pumps.find((p) => p?.pump === pumpNumber)?.role
        if (!role) return null
        return PUMP_OPTIONS.find((o) => o.value === role) ?? { value: role, label: role }
    }, [pumps, pumpNumber])

    return (
        <div className="flex w-full min-w-0 flex-col gap-2">
            <Label className="text-sm text-zinc-300">Pump {pumpNumber + 1}</Label>
            <Select<PumpOption, false>
                instanceId={`pump-type-${pumpNumber}`}
                inputId={`pump-type-input-${pumpNumber}`}
                classNamePrefix="hydro-pump-type"
                options={PUMP_OPTIONS}
                value={value}
                placeholder="Choose pump type…"
                onChange={(opt: SingleValue<PumpOption>) => {
                    const role = opt?.value ?? ''
                    setPumps((prev) => {
                        const next = prev.filter((p) => p?.pump !== pumpNumber)
                        next.push({ pump: pumpNumber, role })
                        return next
                    })
                }}
                styles={pumpSelectStyles}
                menuPortalTarget={
                    typeof document !== 'undefined' ? document.documentElement : undefined
                }
                menuPosition="fixed"
                menuPlacement="auto"
                isSearchable={false}
                blurInputOnSelect
                className={cn('w-full min-w-0')}
            />
        </div>
    )
}

export default PumpType
